import React from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import Image from 'gatsby-image'
import { Parallax } from 'react-scroll-parallax'

import Button from '../../components/Button'
import findImage from '../../utils/findImage'

import styles from './services.module.scss'

// List of works that will have smaller tiles
const smallWorks = [
  'bifit-logo',
  // 'feedbird-logo',
  // 'podari-logo',
  //  'suvenirka-logo',
  //  'gde-logo',
  'rfs-style',
  'vip-garant-logo',
  'vitosoft-logo',
]

// Tiles of the works
const IdentityWorksGrid = () => {
  const query = useStaticQuery(
    graphql`
      query {
        allJavascriptFrontmatter(
          filter: { frontmatter: { path: { regex: "^/identity/" } } }
        ) {
          edges {
            node {
              ...WorkData
            }
          }
        }
        allFile(filter: { name: { regex: "^/-demo/" } }) {
          edges {
            node {
              ...WorkImage
            }
          }
        }
      }
    `
  )

  const works = query.allJavascriptFrontmatter
    ? query.allJavascriptFrontmatter.edges
    : null

  const workImages = query.allFile.edges

  return (
    <Parallax y={[20, -10]}>
      <div className={styles.worksContainer}>
        {works.map(({ node: work }, index) => {
          const { title, path, image } = work.frontmatter
          const className = [
            styles.worksContainerItem,
            smallWorks.find(item => {
              return path.includes(item)
            })
              ? styles.small
              : null,
          ].join(' ')

          return (
            <div className={className} key={index}>
              <Link to={path}>
                <Image
                  fluid={findImage(workImages, image)}
                  alt={title}
                />
              </Link>
            </div>
          )
        })}
      </div>
    </Parallax>
  )
}


// Section template
 
const Identity = () => {
  const className = [styles.section, styles.identity].join(' ')
  return (
    <section className={className}>
      <div className={styles.sectionText}>
        <div className={styles.sectionCount}>2</div>
        <h2>Identity</h2>
        <p>
          Logotypes, icons and other brand artifacts. I create positive brand
          appearance, naming, and style book.
        </p>
        <Button to="/works/identity/">All Identity</Button>
      </div>
      <div className={styles.identityWorks}>
        <IdentityWorksGrid />
      </div>
    </section>
  )
}

export default Identity
